const enviromentSelect = (enviroment: string | undefined): string => {
  switch (enviroment) {
    case 'production':
      return 'https://facturacion.todogas.mx:443';
    default:
      return 'http://localhost:8765';
  }
};

export const GATEWAY_API_URL: string | undefined = enviromentSelect(
  process.env.REACT_APP_STAGE,
);
export const CORE_SERVICE_KEY = 'api';
